import { ArrowBack, ArrowForward, CloseRounded } from '@mui/icons-material'
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Tab,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { linkUsers, toggleFormLinkUsers } from '../../../../../../../redux/actions/users'
import { IRootState } from '../../../../../../../redux/types'
import { StyledTabs } from '../../../../../../shared/components/StyledTabs'
import TabPanel from '../../../../../../shared/components/TabPanel'
import { CancelButton, SaveButton } from '../../../../../../shared/components/inputs'
import useBooleanState from '../../../../../../shared/hooks/useBooleanState'
import useScreenWidth from '../../../../../../shared/hooks/useScreenWidth'
import useTabState from '../../../../../../shared/hooks/useTabState'
import { StyledDialog } from '../../../../../../shared/styles/StyledDialog'
import { isManager } from '../../../../utils/RolesHelper'
import { useUserTransferFilters } from '../../../hooks/modals/transfer/useUserTransferFilters'
import { UserTransferFilters } from './UserTransferFilters'
import { UserTransferTable } from './UserTransferTable'

function UserTransferModal({ showBotton = true }: { showBotton?: boolean }) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected, dependents, notdependents, showLinkForm } = useSelector((state: IRootState) => state.user)
  const { currentTab, setCurrentTab, a11yProps } = useTabState()
  const [openConfirm, setOpenConfirm] = useState(false)
  const [parent, setParent] = useState<any>(null)
  const [disableParentInput, setDisableParentInput] = useBooleanState(false)
  const [selectedLeftRows, setSelectedLeftRows] = useState<any>([])
  const [selectedRightRows, setSelectedRightRows] = useState<any>([])
  const [tmpRows, setTmpRows] = useState({
    left: dependents,
    right: []
  })
  const { filters, setFilters, usersFiltered } = useUserTransferFilters(tmpRows)
  const [rightOriginalRows, setRightOriginalRows] = useState([])

  useEffect(() => {
    if (parent !== null) {
      if (JSON.stringify(rightOriginalRows) !== JSON.stringify(tmpRows.right)) {
        setDisableParentInput(true)
      } else {
        setDisableParentInput(false)
      }
    }
  }, [tmpRows.right])

  useEffect(() => {
    setTmpRows({ ...tmpRows, left: dependents, right: [] })
  }, [dependents])

  const handleOpenConfirm = () => {
    setOpenConfirm(true)
  }

  const handleCloseConfirm = () => {
    setOpenConfirm(false)
  }

  const handleAutoCompleteChange = (inputName: string) => (_: any, value: any) => {
    // Parent Filter
    if (inputName === 'parent') {
      let usersFilteredR: any = []
      if (value !== null) {
        let parentFilter: any = []
        notdependents.map((user: any) => {
          if (user?.parents?.split(',').includes(value.id.toString())) {
            parentFilter.push(user)
          }
        })
        usersFilteredR = parentFilter
        setParent(value)
      } else setParent(null)

      setTmpRows({ ...tmpRows, right: usersFilteredR })
      setRightOriginalRows(usersFilteredR)
    } else {
      if (value !== null) setFilters({ ...filters, [inputName]: value })
      else setFilters({ ...filters, [inputName]: [] })
    }
  }

  const handleMultiAutoCompleteChange = (inputName: string) => (_: any, value: any) => {
    let optionsMulti = []
    if (value !== null) {
      for (let i = 0; i < value.length; i++) {
        if (['postalcodesL', 'postalcodesR'].includes(inputName)) {
          optionsMulti.push(value[i].code)
        } else {
          optionsMulti.push(value[i].id)
        }
      }
    }

    setFilters({ ...filters, [inputName]: optionsMulti })
  }

  // Manage tranfer list movement
  const handleToogle = (toward: string) => {
    let leftRowsResult: any = []
    let rigthRowsResult: any = []
    let filter_ids: any = []
    if (toward === '>') {
      // Set ckecked props of selected rows to false
      let selectedLeftRowsPure = [...selectedLeftRows]
      for (const index in selectedLeftRowsPure) {
        if (Object.prototype.hasOwnProperty.call(selectedLeftRowsPure, index)) {
          selectedLeftRowsPure[index].tableData.checked = false
          filter_ids.push(selectedLeftRowsPure[index].id)

          // Avoid assign duplicate rows
          if (tmpRows.right.some((rightRow: any) => rightRow.id === selectedLeftRowsPure[index].id))
            selectedLeftRowsPure.splice(Number.parseInt(index), 1)
        }
      }

      // Add to right list, Rows checked from left
      rigthRowsResult = [...tmpRows.right, ...selectedLeftRowsPure]

      // Delete selected rows
      if (filters.typeLink === 1) {
        leftRowsResult = tmpRows.left.filter((row: any) => !filter_ids.includes(row.id))
      } else {
        leftRowsResult = tmpRows.left
      }

      setTmpRows({ ...tmpRows, left: leftRowsResult, right: rigthRowsResult })
      setSelectedLeftRows([])
    } else if (toward === '<') {
      // Set ckecked props of selected rows to false
      let selectedRightRowsPure = [...selectedRightRows]
      for (const index in selectedRightRowsPure) {
        if (Object.prototype.hasOwnProperty.call(selectedRightRowsPure, index)) {
          selectedRightRowsPure[index].tableData.checked = false
          filter_ids.push(selectedRightRowsPure[index].id)

          // Avoid assign duplicate rows
          if (tmpRows.left.some((leftRow: any) => leftRow.id === selectedRightRowsPure[index].id))
            selectedRightRowsPure.splice(Number.parseInt(index), 1)
        }
      }

      // Add to left list, Rows checked from right
      leftRowsResult = [...tmpRows.left, ...selectedRightRowsPure]

      // Delete selected rows
      rigthRowsResult = tmpRows.right.filter((row: any) => !filter_ids.includes(row.id))

      setTmpRows({ ...tmpRows, right: rigthRowsResult, left: leftRowsResult })
      setSelectedRightRows([])
    }
  }

  const handleSelectionRows = (side: string, rows: any) => {
    if (side === 'left') setSelectedLeftRows(rows)
    else if (side === 'right') setSelectedRightRows(rows)
  }

  const handleModalCreate = (type: number) => {
    // Reset filters
    setFilters({
      brandsL: [],
      countriesL: [],
      provinceL: [],
      postalcodesL: [],
      brandsR: [],
      countriesR: [],
      provinceR: [],
      postalcodesR: [],
      typeLink: type
    })

    // Reset tables
    setTmpRows({ ...tmpRows, left: dependents, right: [] })

    // Clean parent
    setParent(null)

    // Open modals
    dispatch(toggleFormLinkUsers())
  }

  const handleSubmit = () => {
    // Get user ids of Trasnfer Lists
    let rows: any = { ...tmpRows }
    let leftUserIds: number[] = []
    let rightUserIds: number[] = []
    for (const key in rows) {
      if (Object.prototype.hasOwnProperty.call(rows, key)) {
        for (const index in rows[key]) {
          if (Object.prototype.hasOwnProperty.call(rows[key], index)) {
            if (key === 'left') leftUserIds.push(rows[key][index].id)
            else if (key === 'right') rightUserIds.push(rows[key][index].id)
          }
        }
      }
    }

    // Save Link Users
    dispatch(
      linkUsers({
        userProfileId: userProfileSelected.id,
        parent_id: Object.keys(parent) ? parent.id : null,
        leftUserIds,
        rightUserIds
      })
    )
  }

  return (
    <>
      {showBotton && isManager(authUser.role_id) && (
        <Grid id="linked-users-buttons" container spacing={2} justifyContent={isMobile ? 'space-around' : 'flex-start'}>
          <Grid>
            <Tooltip title={`${t('admin.people.link-people-message')}`}>
              <Button variant="contained" color="primary" onClick={() => handleModalCreate(2)} size="small">
                {t('admin.people.link-people')}
              </Button>
            </Tooltip>
          </Grid>
          <Grid>
            <Tooltip title={`${t('admin.people.change-link-message')}`}>
              <Button variant="outlined" color="primary" onClick={() => handleModalCreate(1)} size="small">
                {t('admin.people.change-link')}
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      )}

      <Dialog
        open={showLinkForm}
        fullScreen={true}
        onClose={() => dispatch(toggleFormLinkUsers())}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">{filters.typeLink === 1 ? t('admin.people.change-link') : t('admin.people.link-people')}</Typography>
            <Button onClick={() => dispatch(toggleFormLinkUsers())} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>

        <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
          <form noValidate autoComplete="nope">
            <Grid container alignItems="flex-start" justifyContent="space-between" spacing={2}>
              <Grid xs={12} sm={6}>
                <TextField
                  label={t('admin.people.person-in-charge')}
                  fullWidth
                  disabled
                  margin="normal"
                  value={userProfileSelected.name}
                  InputLabelProps={{ shrink: true }}
                  variant="filled"
                />
              </Grid>

              <Grid xs={12} sm={6}>
                <FormControl fullWidth variant="filled">
                  <Autocomplete
                    id="combo-box-people"
                    value={parent}
                    onChange={handleAutoCompleteChange('parent')}
                    disabled={disableParentInput}
                    options={notdependents.filter((user: any) => user.role_id !== 6)}
                    getOptionLabel={(option: any) => (option.id !== undefined ? `${option.name} <${option.email}>` : '')}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label={`${t('search')} ${t('admin.people.people-linked-with')}`}
                        variant="filled"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid xs={12}>
              <StyledTabs value={currentTab} onChange={(_, value) => setCurrentTab(value)} aria-label="disabled tabs example">
                <Tab label={t('admin.people.quick')} {...a11yProps(0)} />
                <Tab label={t('admin.people.advanced')} {...a11yProps(1)} />
              </StyledTabs>
            </Grid>
            <TabPanel value={currentTab} index={0} />
            <TabPanel value={currentTab} index={1}>
              <UserTransferFilters
                filters={filters}
                handleAutoCompleteChange={handleAutoCompleteChange}
                handleMultiAutoCompleteChange={handleMultiAutoCompleteChange}
              />
            </TabPanel>

            <Grid container spacing={2} justifyContent="center" alignItems="center" style={{ paddingTop: 8 }}>
              <Grid xs={12} md={true}>
                <div className="table_custom white border">
                  <UserTransferTable side={'left'} rows={usersFiltered.left} handleSelectionRows={handleSelectionRows} />
                </div>
              </Grid>
              <Grid xs={12} md={1}>
                <Grid container direction="column" alignItems="center">
                  <IconButton
                    onClick={() => handleToogle('>')}
                    disabled={selectedLeftRows.length === 0 || parent === null}
                    color="secondary"
                    aria-label="move selected right"
                  >
                    <ArrowForward />
                  </IconButton>
                  <IconButton
                    onClick={() => handleToogle('<')}
                    disabled={selectedRightRows.length === 0 || parent === null}
                    aria-label="move selected left"
                    color="secondary"
                  >
                    <ArrowBack />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid xs={12} md={true}>
                <div className="table_custom white border">
                  <UserTransferTable side={'left'} rows={usersFiltered.right} handleSelectionRows={handleSelectionRows} />
                </div>
              </Grid>
            </Grid>
          </form>
        </DialogContent>

        <DialogActions>
          <CancelButton onClick={() => dispatch(toggleFormLinkUsers())} aria-label="close">
            {t('cancel')}
          </CancelButton>

          <SaveButton autoFocus id="btn-handlelogin" disabled={!parent} onClick={() => handleOpenConfirm()}>
            {t('save')}
          </SaveButton>
        </DialogActions>
      </Dialog>

      {/* Modal de confirmación */}
      <StyledDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        aria-labelledby="form-dialog-title"
        aria-describedby="form-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">
              {t('continue')} {filters.typeLink === 1 ? t('admin.people.change-link') : t('admin.people.link-people')}
            </Typography>
            <Button onClick={handleCloseConfirm} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>
        <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid xs={12}>
              <Typography>
                {filters.typeLink === 1 ? t('admin.people.change-link-message') : t('admin.people.link-people-message')}
                <br />
                {t('confirm-action')}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={() => handleCloseConfirm()} aria-label="close">
            {t('cancel')}
          </CancelButton>
          <SaveButton
            autoFocus
            id="btn-handlelogin"
            onClick={() => {
              handleSubmit()
              handleCloseConfirm()
            }}
          >
            {t('allow')}
          </SaveButton>
        </DialogActions>
      </StyledDialog>
    </>
  )
}

export default UserTransferModal
